import { render, staticRenderFns } from "./AbcAvalForm.vue?vue&type=template&id=908660c4"
import script from "./AbcAvalForm.vue?vue&type=script&lang=js"
export * from "./AbcAvalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports